module.exports = __webpack_public_path__ + "media/images/common/nav_mobile-88653fa2d9446214864a41fee6ef9edd.png";